import React from 'react';
import StatusProgress from '@mpc/common/src/features/StatusProgress';

// 状态进度：经共享组件 StatusProgress 分发层按 groupType 映射真实接口。
// mpc-external 下 $sType='outer'，自动命中 journalMapConfig.outer.IP_COOPERATION_GROUP。
// show 恒 true：本组件仅在状态进度抽屉打开时挂载（Drawer destroyOnClose），每次打开即请求；
// state 仅作 StatusProgress 内部 useEffect 依赖，命令式抽屉每次重 mount，传空串即可。

interface StatusProgressTabProps {
  detailId: number;
}

const StatusProgressTab: React.FC<StatusProgressTabProps> = ({ detailId }) => (
  <StatusProgress projectId={detailId} show state="" groupType="IP_COOPERATION_GROUP" />
);

export default StatusProgressTab;
